var $291e2fb947064c57$exports = {};
$291e2fb947064c57$exports = {
    "loading": `Laden...`,
    "placeholder": `Ausw\xe4hlen\u{2026}`
};


export {$291e2fb947064c57$exports as default};
//# sourceMappingURL=de-DE.module.js.map
